module.exports = __webpack_public_path__ + "img/belt-1.fde17ef6.png";